// import {
//   Noto_Sans_KR,
//   Noto_Sans_JP,
//   Noto_Sans_SC,
//   Noto_Sans_TC,
//   Noto_Sans_Arabic,
//   Noto_Sans_Thai,
//   Noto_Sans_Lao,
//   Noto_Sans,
// } from "next/font/google";

// export const getFontClass = (locale: string) => {
//   switch (locale) {
//     case "ko":
//       return notoSansKr.className;
//     case "ja":
//       return notoSansJp.className;
//     case "zh-cn":
//       return notoSansSc.className;
//     case "zh-tw":
//       return notoSansTc.className;
//     case "zh-hk":
//       return notoSansTc.className;
//     case "ar":
//       return notoSansArabic.className;
//     case "th": // 태국
//       return notoSansThai.className;
//     case "lo": //라오스
//       return notoSansLao.className;
//     default:
//       return notoSans.className;
//   }
// };

// const notoSansKr = Noto_Sans_KR({
//   subsets: ["latin"],
//   weight: ["400", "500", "600", "700"],
//   display: "swap",
// });

// const notoSansJp = Noto_Sans_JP({
//   subsets: ["latin"],
//   weight: ["400", "500", "600", "700"],
//   display: "swap",
// });

// const notoSansSc = Noto_Sans_SC({
//   subsets: ["latin"],
//   weight: ["400", "500", "600", "700"],
//   display: "swap",
// });

// const notoSansTc = Noto_Sans_TC({
//   subsets: ["latin"],
//   weight: ["400", "500", "600", "700"],
//   display: "swap",
// });

// const notoSansThai = Noto_Sans_Thai({
//   subsets: ["latin"],
//   weight: ["400", "500", "600", "700"],
//   display: "swap",
// });

// const notoSansArabic = Noto_Sans_Arabic({
//   subsets: ["arabic"],
//   weight: ["400", "500", "600", "700"],
//   display: "swap",
// });

// const notoSansLao = Noto_Sans_Lao({
//   subsets: ["latin"],
//   weight: ["400", "500", "600", "700"],
//   display: "swap",
// });

// const notoSans = Noto_Sans({
//   subsets: ["cyrillic-ext", "latin-ext"],
//   weight: ["400", "500", "600", "700"],
//   display: "swap",
// });

import localFont from "next/font/local";

export const getFontClass = (locale: string) => {
  switch (locale) {
    case "ko":
      return notoSansKr.className;
    case "ja":
      return notoSansJp.className;
    case "zh-cn":
      return notoSansSc.className;
    case "zh-tw":
    case "zh-hk":
      return notoSansTc.className;
    case "ar":
      return notoSansArabic.className;
    case "th": // 태국
      return notoSansThai.className;
    case "lo": // 라오스
      return notoSansLao.className;
    default:
      return notoSans.className;
  }
};

const notoSansKr = localFont({
  src: [
    {
      path: "./assets/fonts/noto-sans-kr-v36-korean_latin-regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-kr-v36-korean_latin-500.woff2",
      weight: "500",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-kr-v36-korean_latin-600.woff2",
      weight: "600",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-kr-v36-korean_latin-700.woff2",
      weight: "700",
      style: "normal",
    },
  ],
  variable: "--font-kr",
  display: "swap",
  preload: false,
});

const notoSansJp = localFont({
  src: [
    {
      path: "./assets/fonts/noto-sans-jp-v53-latin-regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-jp-v53-latin-500.woff2",
      weight: "500",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-jp-v53-latin-600.woff2",
      weight: "600",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-jp-v53-latin-700.woff2",
      weight: "700",
      style: "normal",
    },
  ],
  variable: "--font-jp",
  display: "swap",
  preload: false,
});

const notoSansSc = localFont({
  src: [
    {
      path: "./assets/fonts/noto-sans-sc-v37-latin-regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-sc-v37-latin-500.woff2",
      weight: "500",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-sc-v37-latin-600.woff2",
      weight: "600",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-sc-v37-latin-700.woff2",
      weight: "700",
      style: "normal",
    },
  ],
  variable: "--font-sc",
  display: "swap",
  preload: false,
});

const notoSansTc = localFont({
  src: [
    {
      path: "./assets/fonts/noto-sans-tc-v36-latin-regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-tc-v36-latin-500.woff2",
      weight: "500",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-tc-v36-latin-600.woff2",
      weight: "600",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-tc-v36-latin-700.woff2",
      weight: "700",
      style: "normal",
    },
  ],
  variable: "--font-tc",
  display: "swap",
  preload: false,
});

const notoSansThai = localFont({
  src: [
    {
      path: "./assets/fonts/noto-sans-thai-v25-latin_thai-regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-thai-v25-latin_thai-500.woff2",
      weight: "500",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-thai-v25-latin_thai-600.woff2",
      weight: "600",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-thai-v25-latin_thai-700.woff2",
      weight: "700",
      style: "normal",
    },
  ],
  variable: "--font-thai",
  display: "swap",
  preload: false,
});

const notoSansArabic = localFont({
  src: [
    {
      path: "./assets/fonts/noto-sans-arabic-v29-arabic_latin-regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-arabic-v29-arabic_latin-500.woff2",
      weight: "500",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-arabic-v29-arabic_latin-600.woff2",
      weight: "600",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-arabic-v29-arabic_latin-700.woff2",
      weight: "700",
      style: "normal",
    },
  ],
  variable: "--font-arabic",
  display: "swap",
  preload: false,
});

const notoSansLao = localFont({
  src: [
    {
      path: "./assets/fonts/noto-sans-lao-v30-lao_latin-regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-lao-v30-lao_latin-500.woff2",
      weight: "500",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-lao-v30-lao_latin-600.woff2",
      weight: "600",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-lao-v30-lao_latin-700.woff2",
      weight: "700",
      style: "normal",
    },
  ],
  variable: "--font-lao",
  display: "swap",
  preload: false,
});

const notoSans = localFont({
  src: [
    {
      path: "./assets/fonts/noto-sans-v39-cyrillic-ext_devanagari_greek_latin-ext_vietnamese-regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-v39-cyrillic-ext_devanagari_greek_latin-ext_vietnamese-500.woff2",
      weight: "500",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-v39-cyrillic-ext_devanagari_greek_latin-ext_vietnamese-600.woff2",
      weight: "600",
      style: "normal",
    },
    {
      path: "./assets/fonts/noto-sans-v39-cyrillic-ext_devanagari_greek_latin-ext_vietnamese-700.woff2",
      weight: "700",
      style: "normal",
    },
  ],
  variable: "--font-sans",
  display: "swap",
  preload: false,
});

export const urbanist = localFont({
  src: [
    {
      path: "./assets/fonts/urbanist-v15-latin-regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "./assets/fonts/urbanist-v15-latin-500.woff2",
      weight: "500",
      style: "normal",
    },
    {
      path: "./assets/fonts/urbanist-v15-latin-600.woff2",
      weight: "600",
      style: "normal",
    },
    {
      path: "./assets/fonts/urbanist-v15-latin-700.woff2",
      weight: "700",
      style: "normal",
    },
    {
      path: "./assets/fonts/urbanist-v15-latin-800.woff2",
      weight: "800",
      style: "normal",
    },
  ],
  variable: "--font-urbanist",
  display: "swap",
  preload: false,
});

export const roboto = localFont({
  src: [
    {
      path: "./assets/fonts/roboto-regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "./assets/fonts/roboto-medium.woff2",
      weight: "500",
      style: "normal",
    },
    {
      path: "./assets/fonts/roboto-medium.woff2",
      weight: "600",
      style: "normal",
    },
    {
      path: "./assets/fonts/roboto-medium.woff2",
      weight: "700",
      style: "normal",
    },
    {
      path: "./assets/fonts/roboto-medium.woff2",
      weight: "800",
      style: "normal",
    },
  ],
  variable: "--font-urbanist",
  display: "swap",
  preload: false,
});
